// extracted by mini-css-extract-plugin
export default {"label":"EditUserRole_label__Y3C2F","description":"EditUserRole_description__qUb8N"};